<script setup>
import { ref, inject, onMounted, onBeforeUnmount } from 'vue'
import TheFeed from '@/components/Feed/TheFeed.vue'
import { useStorage } from '@vueuse/core'

const notificationOpen = ref(false)
const modalPosts = ref(null)
const creatorName = inject('creatorName', null)

const notificationOpened = useStorage('for-you-opened', false)

let timeoutId = null

function handleClick () {
  if (timeoutId) {
    clearTimeout(timeoutId)
  }

  notificationOpened.value = true

  notificationOpen.value = false
  modalPosts.value.openModal()

  // notificationOpen.value = true
}

onMounted(() => {
  if (notificationOpened.value) {
    notificationOpen.value = false
    return
  }

  timeoutId = setTimeout(() => {
    notificationOpened.value = true
    notificationOpen.value = true
  }, 60000)
})

onBeforeUnmount(() => {
  if (timeoutId) {
    clearTimeout(timeoutId)
  }
})
</script>

<template>
  <div
    :class="{ 'w-full': notificationOpen }"
    class="flex items-end justify-between  pointer-events-none">
    <transition name="fade">
      <div
        v-if="notificationOpen"
        style="z-index: 6"
        class="flex-grow w-full px-6 relative">
        <h2
          v-if="creatorName"
          class="font-bold text-2xl text-white mb-1">
          {{ $t('for_you.creators_like', { username: creatorName ? creatorName.split(' ')[0] : '' }) }}
        </h2>

        <p class="text-white">
          {{ $t('for_you.text') }}
        </p>
      </div>
    </transition>

    <button
      type="button"
      style="z-index: 6"
      class="pointer-events-auto relative flex-shrink-0 h-10 w-10 bg-brand rounded-l flex items-center justify-center"
      @click="handleClick">
      <InlineSvg
        class="inline-block w-6 h-6 text-white"
        :src="require('@/assets/svg/navbar/sparkles.svg')"/>

      <transition name="fade">
        <InlineSvg
          v-if="notificationOpen"
          class="inline-block absolute -bottom-14 right-10 pointer-events-none"
          :src="require('@/assets/svg/design/chat-for-you-decoration-arrow.svg')"/>
      </transition>
    </button>

    <teleport to="body">
      <transition name="fade">
        <div
          v-if="notificationOpen"
          style="z-index: 5"
          class="fixed inset-0 bg-black bg-opacity-70"
          @click="notificationOpen = false; modalPosts.openModal()"/>
      </transition>
    </teleport>

    <Modal
      ref="modalPosts"
      v-slot="{ closeModal }"
      name="ThePostsSwiper"
      :is-rounded="false"
      :has-indents="false"
      :is-full-height="true"
      :show-close-cross="false"
      z-index-class="z-20"
      :show-desktop-close-cross="true"
      content-class="h-full mt-10 pb-10 rounded-t-xl overflow-hidden bg-gray-700 relative"
      position="center">
      <button
        class="absolute top-2.5 left-3 z-20 text-white p-1"
        type="button"
        @click="closeModal">
        <InlineSvg
          :src="require('@/assets/fontawesome/regular/xmark.svg')"
          class="w-5 h-5"/>
      </button>

      <TheFeed
        type="public"
        :close-modal="closeModal"/>
    </Modal>
  </div>
</template>
